import { FieldCellMixins } from './mixins.js';

export const IdentityNameCell = {
  mixins: [FieldCellMixins],

  template: `
    <div>
      <span :title='text_value'>{{ text_value }}</span>
      <i class="slp-id-card-o primary-text text-strong" v-if="text_value"></i>
    </div>
  `
};
